/**
 * Trigger a file download in the browser.
 * Creates a temporary anchor element, clicks it, then removes it.
 */
export const triggerDownload = (url: string, filename: string): void => {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
